"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryContentSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _lodash = _interopRequireDefault(require("lodash.times"));
var _hooks = require("../../../hooks");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CategoryContentSkeleton = ({
  animation
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _hooks.useIsMobile)();
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MobileSkeletonRoot, {
      "data-testid": getTestId(_constants.CATEGORY_CONTENT_MOBILE_SKELETON),
      children: (0, _lodash.default)(5).map(index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MobileItemSkeleton, {
        animation: animation,
        height: 30,
        width: "100%"
      }, `mobile-item-${index}`))
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DesktopSkeletonRoot, {
    "data-testid": getTestId(_constants.CATEGORY_CONTENT_DESKTOP_SKELETON),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopItemSkeleton, {
      height: 36,
      width: 100,
      animation: animation
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopItemSkeleton, {
      height: 36,
      width: 100,
      animation: animation
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopSkeletonInner, {
      children: (0, _lodash.default)(20).map(index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopItemSkeleton, {
        height: 26,
        width: 100,
        animation: animation
      }, `desktop-item-${index}`))
    })]
  });
};
exports.CategoryContentSkeleton = CategoryContentSkeleton;
